import { type TypePolicy } from '@apollo/client';

export const TeacherInfo: TypePolicy = {
    keyFields: false,
    merge: true,
};
